import React, { useEffect, useRef, useState } from 'react';
import Plyr from 'plyr-react';
import 'plyr/dist/plyr.css';

function Video({ videoSrc }) {
    const playerRef = useRef();
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

    useEffect(() => {
        const player = playerRef.current;
        if (player) {
            const handleEnded = () => {
                console.log('next');
                setCurrentVideoIndex((prevIndex) =>
                    prevIndex < videoSrc.length - 1 ? prevIndex + 1 : 0 // Loop back to the first video
                );
            };
            player.on('ended', handleEnded);
            return () => {
                player.off('ended', handleEnded);
            };
        }
    }, [videoSrc]);

    return (
        <div className="w-full aspect-w-16 aspect-h-8 rounded-lg">
            {videoSrc.length > 0 ? (
                <Plyr
                    ref={playerRef}
                    source={{
                        type: 'video',
                        sources: [{ src: videoSrc[currentVideoIndex].url, type: 'video/mp4' }],
                    }}
                    options={{
                        autoplay: false,
                    }}
                />
            ) : (
                <div>No videos available</div>
            )}
        </div>
    );
}


export default Video;

